<script setup lang="ts">
import vReveal from "@/application/directives/vReveal";

const before = [
  "Een groepsapp met 40 ongelezen berichten over de bardienst",
  "Een Excel-planning die alleen de penningmeester nog opent",
  "Steeds dezelfde vrijwilligers bellen omdat niemand reageert",
  "Geen idee wie zijn vrijwilligersuren dit seizoen al heeft gehaald",
];

const after = [
  "Leden zien open taken en melden zich zelf aan - vol is vol",
  "Eén overzicht per categorie, taak en seizoen voor het bestuur",
  "Automatische bevestiging per e-mail, geen nabellen",
  "Vrijwilligersuren, vrijstellingen en afkoop netjes vastgelegd",
];
</script>

<template>
  <section id="besturen" class="compare">
    <VContainer class="landing-container">
      <div v-reveal class="compare__header">
        <p class="landing-eyebrow">Herkenbaar voor elk bestuur</p>
        <h2 class="landing-h2">
          Van rondbelrondje naar één duidelijk overzicht.
        </h2>
      </div>

      <VRow v-reveal class="ga-0">
        <VCol cols="12" sm="6">
          <VCard class="compare__card" variant="outlined">
            <h3 class="landing-h3 mb-4">Zonder Klupz</h3>
            <ul class="compare__list">
              <li v-for="item in before" :key="item">
                <VIcon icon="$cancel" size="18" color="border" />
                {{ item }}
              </li>
            </ul>
          </VCard>
        </VCol>

        <VCol cols="12" sm="6">
          <VCard class="compare__card compare__card--after" variant="outlined">
            <h3 class="landing-h3 mb-4">Met Klupz</h3>
            <ul class="compare__list">
              <li v-for="item in after" :key="item">
                <VIcon icon="$success" size="18" color="primary" />
                {{ item }}
              </li>
            </ul>
          </VCard>
        </VCol>
      </VRow>
    </VContainer>
  </section>
</template>

<style scoped lang="scss">
.compare {
  padding: 48px 0;
}

.compare__header {
  max-width: 60ch;
  margin-bottom: 32px;
}

.compare__card {
  height: 100%;
  padding: 28px;
  border-radius: 16px;
}

.compare__card--after {
  border-color: #c7d9fb;
  background: linear-gradient(180deg, #f7faff, rgb(var(--v-theme-surface)) 40%);
}

.compare__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;

  li {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    font-size: 14.5px;
    color: rgb(var(--v-theme-font-color));

    .v-icon {
      margin-top: 2px;
      flex-shrink: 0;
    }
  }
}
</style>
